import { Injectable } from '@angular/core';
import { dewsIIIMedicalHistoryAutopopulateConfig } from 'src/app/encounters/encounter-linking/dews-iii-medical-history-linking';
import { medicalHistoryCustomAutopopulateConfig } from 'src/app/encounters/encounter-linking/medical-history-linking';
import { AutopopulateService } from 'src/app/shared/autopopulate/autopopulate.service';
import { DryEyeMedicalHistoryFormGroup } from 'src/app/shared/consult-forms/dry-eye-forms/dry-eye-medical-history-form/dry-eye-medical-history-form.model';
import { MedicalHistoryPopulator } from '../medical-history-source.model';

/**
 * Applies CUSTOM / FITZPATRICK / MEDICATION questionnaire answers through the
 * declarative autopopulate config.
 */
@Injectable({ providedIn: 'root' })
export class CustomQuestionnairePopulator implements MedicalHistoryPopulator {
  constructor(private autopopulateService: AutopopulateService) {}

  populate(formGroup: DryEyeMedicalHistoryFormGroup, answers: any): void {
    this.autopopulateService.populateFormGroup(
      formGroup,
      medicalHistoryCustomAutopopulateConfig,
      answers,
      false
    );
  }
}

/**
 * Applies DEWS-III questionnaire answers through its autopopulate config.
 */
@Injectable({ providedIn: 'root' })
export class DewsIiiPopulator implements MedicalHistoryPopulator {
  constructor(private autopopulateService: AutopopulateService) {}

  populate(formGroup: DryEyeMedicalHistoryFormGroup, answers: any): void {
    this.autopopulateService.populateFormGroup(
      formGroup,
      dewsIIIMedicalHistoryAutopopulateConfig,
      answers,
      false
    );
  }
}
